import { Model, Attr } from 'spraypaint';
import { RecordProxy } from 'spraypaint/lib-esm/proxies';
import ApplicationRecord from 'spa-ionata-admin/lib/models/ApplicationRecord';

@Model()
export default class SiteLayout extends ApplicationRecord {
  static jsonapiType = 'site-layouts';

  // --- Attributes
  // --------------

  @Attr() header!: string;

  @Attr() footer!: string;

  // --- Custom
  // ----------

  static fetchLayout(): Promise<RecordProxy<SiteLayout>> {
    return SiteLayout.find('1');
  }
}
